import React from 'react'
import { useTranslation } from 'react-i18next'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Doughnut } from 'react-chartjs-2'
import { statuses } from '../../tendering/components/TenderStatus'

interface TenderDonutChartProps {
  byStatus: Array<{ status: string; count: number }>
  total: number
}

const TenderDonutChart: React.FC<TenderDonutChartProps> = ({ byStatus, total }) => {
  const { t } = useTranslation()

  if (total === 0) {
    return (
      <Card className="h-full">
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium">{t('Dashboard_tender_chart_title', 'Tenders by Status')}</CardTitle>
        </CardHeader>
        <CardContent className="flex items-center justify-center h-[200px]">
          <p className="text-sm text-muted-foreground">{t('Dashboard_no_tenders', 'No tenders yet')}</p>
        </CardContent>
      </Card>
    )
  }

  const labels = byStatus.map((s) => {
    const st = statuses[s.status]
    return `${st ? t(st.title) : s.status} (${s.count})`
  })
  const data = byStatus.map((s) => s.count)
  const backgroundColor = byStatus.map((s) => statuses[s.status]?.hex || '#64748b')

  const chartData = {
    labels,
    datasets: [
      {
        data,
        backgroundColor,
        borderWidth: 0,
      },
    ],
  }

  const options = {
    cutoutPercentage: 55,
    legend: { position: 'bottom' as const, labels: { boxWidth: 12, fontSize: 11 } },
    tooltips: { enabled: true },
    maintainAspectRatio: true,
  }

  return (
    <Card className="h-full">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium">{t('Dashboard_tender_chart_title', 'Tenders by Status')}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="max-w-[220px] mx-auto">
          <Doughnut data={chartData} options={options} />
        </div>
      </CardContent>
    </Card>
  )
}

export default TenderDonutChart
